import { Fragment, useEffect, useState } from "react";
import subscriptionBg from "assets/images/others/host-side-images/subscriptionBg.png";
import { ReactComponent as PlansSvg } from "assets/images/svgs/Planspricing.svg";
import { ReactComponent as StarSvg } from "assets/images/svgs/subStar.svg";
import { ReactComponent as VerifiedSvg } from "assets/images/svgs/subsVerified.svg";
import Breadcrumb, { BreadcrumbLink } from "components/breadcrumbs";
import { siteRoutes } from "utils/helpers/enums/routes";
import useHost from "../useHooks";
import { SubscriptionDTO } from "utils/helpers/models/host-dtos/subscription.dto";
import { SUBSCRIPTION_TYPES } from "utils/helpers/enums/shared.enum";
import { CheckoutSessionDTO } from "utils/helpers/models/host-dtos/checkout-session.dto";
import { confirmationPopup } from "utils/helpers/common/alert-service";
import useAuth from "containers/auth/useHooks";
import useStore from "hooks/useStore";
import useUtils from "hooks/useUtils";
import CancelSubscriptionModal from "./component/CancelSubscriptionModal";
import CustomMessageDisplay from "components/data-not-found/CustomMessageDisplay";
import subscriptionNotFound from "assets/images/gifs/subscription-not-found.gif";
import { useNavigate } from "react-router-dom";

const Subscription = () => {
  const breadcrumbLinks: BreadcrumbLink[] = [
    { title: "Home ", path: siteRoutes.home },
    { title: "Subscription", path: siteRoutes.subscription },
  ];
  const navigate = useNavigate();
  const { isProfileCompleted } = useStore();

  // Check profile completion on mount - redirect to home if not completed
  useEffect(() => {
    const profileCompleted = isProfileCompleted();
    if (!profileCompleted) {
      navigate(siteRoutes.home, { replace: true });
    }
  }, [isProfileCompleted, navigate]);

  const [plans, setPlans] = useState<SubscriptionDTO[]>([]);
  const {
    getSubscriptionPlans,
    createCheckoutSession,
    hostCancelSubscribtion,
    hostResumeSubscribtion,
  } = useHost();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { getDateTime } = useUtils();
  const { getUserProfile } = useAuth();
  const { getUserSubscription } = useStore();
  const subscription = getUserSubscription();
  const { getUser } = useStore();
  const userData = getUser();

  useEffect(() => {
    getSubscriptionPlans(setPlans);
    getUserProfile();
  }, []);

  const cancelPeriodEnd = userData?.user?.subscription?.cancelAtPeriodEnd;

  console.log(cancelPeriodEnd, "cancelPeriodEndcancelPeriodEndcancelPeriodEnd");

  const getStars = (type: SUBSCRIPTION_TYPES): number[] => {
    if (type === SUBSCRIPTION_TYPES.BASIC) {
      return [1];
    } else if (type === SUBSCRIPTION_TYPES.TIER_1) {
      return [1, 1];
    } else {
      return [1, 1, 1];
    }
  };

  const handleActivatePlan = async (priceId: string) => {
    const result = await confirmationPopup(
      "Are you sure you want to activate this plan?"
    );
    if (result.isConfirmed) {
      const body = new CheckoutSessionDTO({ priceId });
      createCheckoutSession(body);
    }
  };

  const handleResumeSubscription = async () => {
    const result = await confirmationPopup(
      "Are you sure you want to Resume this plan?"
    );
    if (result.isConfirmed) {
      await hostResumeSubscribtion();
    }
  };

  const handleDisableAutoRenew = async () => {
    await hostCancelSubscribtion({ immediately: false });
    setIsModalOpen(false);
  };

  const handleCancelNow = async () => {
    await hostCancelSubscribtion({ immediately: true });
    setIsModalOpen(false);
  };

  return (
    <div>
      <div
        style={{ backgroundImage: `url(${subscriptionBg})` }}
        className=" bg-cover bg-center bg-no-repeat h-full md:h-[500px] w-full"
      >
        <div className="bg-gradient h-full ">
          <div className="container">
            <Breadcrumb links={breadcrumbLinks} />
            <div className=" flex justify-between flex-wrap md:flex-nowrap">
              <div className="flex md:mt-5 flex-col gap-4">
                <p className="text-2xl text-primaryBlueText font-medium">
                  Subscription
                </p>
                <button className="bg-primaryBlueBg text-sm rounded-full px-4 py-2 text-white flex items-center justify-center gap-2 w-fit">
                  <PlansSvg />
                  Plans and pricing
                </button>
                <h2 className="text-4xl text-primaryBlueText">
                  Transparent pricing for all.
                </h2>
                <p className="text-base text-primaryBlueText font-medium mt-3">
                  Get the best service with out subscription plans tailored to
                  make experiences fun and live.
                </p>
              </div>
            </div>
            {/* Cards */}
          </div>
        </div>
      </div>

      {
        plans.length > 0 ? (

          <div className="container flex flex-wrap flex-row gap-4 my-10 md:my-0 md:mt-[-120px]">
          {plans.map((plan, index) => {
            return (
              <div
                className=" bg-white rounded-lg shadow-md w-full sm:w-[316px] mb-10 md:mb-40"
                key={index}
              >
                <div className="border-b border-borderColor py-6 px-8 h-[244px]">
                  <span className="flex gap-3">
                    {getStars(plan.subscriptionType).map((num, index) => {
                      return <StarSvg key={index} />;
                    })}
                  </span>
                  <h2 className="text-2xl text-yellowText mt-2">{plan.name}</h2>
                  <div className="flex items-center gap-1">
                    <div>
                      <p className="text-[42px]">${plan.price}</p>
                    </div>
                    <div className="flex flex-col">
                      {/* <span>
                    <p className="text-primaryBlueText line-through text-sm">$5</p>
                  </span> */}
                      <sub>
                        <p className="text-sm text-primaryBlueText">
                          {plan.interval}
                        </p>
                      </sub>
                    </div>
                  </div>
                  <p className="text-sm text-primaryBlueText mt-1">
                    {plan.description}
                  </p>
                </div>
  
                <div className="flex flex-col justify-between p-6 h-[404px]">
                  <ul className="flex flex-col gap-2">
                    <li>
                      <div className="flex items-start gap-2">
                        <span>
                          <VerifiedSvg className="w-4 h-4 mt-[2px]" />
                        </span>
                        {plan.features.customizable_badge ? (
                          <span className="text-blackie text-sm">
                            {plan.features.level.toUpperCase()} level badge with
                            customized centre (can upload logo or pic)
                          </span>
                        ) : (
                          <span className="text-blackie text-sm">
                            Badge (not customizable) pick one from Learn Local
                            gallery based on service industry
                          </span>
                        )}
                      </div>
                    </li>
  
                    <li>
                      <div className="flex items-start gap-2">
                        <span>
                          <VerifiedSvg className="w-4 h-4  mt-[2px]" />
                        </span>
                        {(plan as any).features.sessions === "unlimited" ? (
                          <span className="text-blackie text-sm">
                            Unlimited sessions per month
                          </span>
                        ) : (
                          <span className="text-blackie text-sm">
                            Host limited to {plan.features.sessions} sessions per
                            month
                          </span>
                        )}
                      </div>
                    </li>
                    {plan.features.post_workshop ? (
                      <li>
                        <div className="flex items-start gap-2">
                          <span>
                            <VerifiedSvg className="w-4 h-4  mt-[2px]" />
                          </span>
                          {plan.features.host_fee_collect ? (
                            <span className="text-blackie text-sm">
                              May post workshop but Learn local will collect{" "}
                              {plan.features.host_fee_collect}% fee of what the
                              host charges
                            </span>
                          ) : (
                            <span className="text-blackie text-sm">
                              Can workshop without any charges from Learn Local
                            </span>
                          )}
                        </div>
                      </li>
                    ) : (
                      ""
                    )}
                  </ul>
                  {/* {plan.stripePriceId && */}
                  <div className="flex flex-col justify-end mt-auto">
                    {subscription?.productId === plan.id ? (
                      <div className="flex flex-col gap-1">
                        <p className="text-center text-gray-500 text-sm">
                          {/* Ends on {getDateTime(subscription?.currentPeriodEnd)} */}
                          {subscription?.currentPeriodEnd === null
                            ? "Subscribe on " +
                              getDateTime(subscription?.updatedAt)
                            : "Ends on " +
                              getDateTime(subscription?.currentPeriodEnd)}
                        </p>
  
                        {/* <button className="w-full py-2 rounded-full text-primaryBlueText font-semibold bg-borderColor cursor-default">
                          Subscribed
                        </button> */}
                        {cancelPeriodEnd ? (
                          <button onClick={handleResumeSubscription} className="w-full py-2 rounded-full text-primaryBlueText font-semibold bg-borderColor cursor-pointer">
                            Resume Subscription
                          </button>
                        ) : (
                          <button
                            onClick={() => {
                              setIsModalOpen(true);
                            }}
                            className="w-full py-2 rounded-full text-primaryBlueText font-semibold bg-borderColor cursor-pointer"
                          >
                            Disable Subscription
                          </button>
                        )}
                      </div>
                    ) : (
                      <Fragment>
                        {" "}
                        <button
                          className="w-full py-2 rounded-full text-white bg-primaryBlueText font-semibold "
                          onClick={() => handleActivatePlan(plan.stripePriceId)}
                        >
                          Active Plan
                        </button>
                      </Fragment>
                    )}
                  </div>
                  {/* } */}
                </div>
              </div>
            );
          })}
        </div>
        ) : (
          <div className="container h-[50vh]">
            <CustomMessageDisplay
              show={true}
              title="No Subscription Plans Found"
              slogan="Please try again later or contact support."
              image={subscriptionNotFound}
              imageAlt="No subscription data"
              className="py-16"
              imageClassName="w-[150px] h-[120px]"
              titleClassName="text-2xl font-bold text-blackie"
              sloganClassName="text-gray-500 text-base"
            />
          </div>
        )}

     
      {isModalOpen && (
        <CancelSubscriptionModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onDisableAutoRenew={handleDisableAutoRenew}
          onCancelNow={handleCancelNow}
        />
      )}
    </div>
  );
};

export default Subscription;
